<template>
  <div class="pt-4">
    <div class="text-h5 text-center my-6">Preguntas frequentes</div>
    <v-expansion-panels flat>
      <v-expansion-panel>
        <v-expansion-panel-header color="secondary" class="text-body-1 font-weight-bold h-panel-header">
          ¿Qué necesito para utilizar BBVA Smart Business LITE?
        </v-expansion-panel-header>
        <v-expansion-panel-content color="secondary">
          Para utilizar BBVA Smart Business LITE necesitas:
          <ol>
            <li>Dátafono Android de BBVA con la app cargada.</li>
            <li>Ordenador. La configuración de la cuenta se hace desde un back-office web (desde cualquier navegador). Recomendamos utilizar un ordenador para una gestión más cómoda.</li>
            <li>La versión completa de la app activada.</li>
          </ol>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="divider" />
      <v-expansion-panel>
        <v-expansion-panel-header color="secondary" class="text-body-1 font-weight-bold h-panel-header">
          ¿La app está sujeta a permanencia?
        </v-expansion-panel-header>
        <v-expansion-panel-content color="secondary">
          No. Puedes cancelar tu suscripción a BBVA Smart Business LITE en cualquier momento. Al darte de baja, se anula la cuenta con efecto en el mes siguiente de facturación en términos de cobro de la cuota.
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="divider" />
      <v-expansion-panel>
        <v-expansion-panel-header color="secondary" class="text-body-1 font-weight-bold h-panel-header">
          Una vez haya contratado la versión completa, ¿qué debo hacer si tengo una incidencia o duda operativa?
        </v-expansion-panel-header>
        <v-expansion-panel-content color="secondary">
          App
          <ul>
            <li>Si tienes alguna <b>duda operativa</b> sobre la app o sobre el back-office, consulta los recursos de soporte que hemos preparado para ayudarte.</li>
            <li>Si tienes algún <b>problema</b> con la app o con el back-office, contáctanos a través de la herramienta de soporte dentro de tu app: Menú / ¿Necesitas ayuda? / Soporte.</li>
          </ul>
          Terminal
          <ul>
            <li>Si necesitas soporte del terminal, contacta con BBVA: 912 249 807 / bbvasmartpay.es@bbva.com</li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="divider" />
      <v-expansion-panel>
        <v-expansion-panel-header color="secondary" class="text-body-1 font-weight-bold h-panel-header">
          ¿Es BBVA Smart Business LITE adecuado para mi negocio?
        </v-expansion-panel-header>
        <v-expansion-panel-content color="secondary">
          <p>BBVA Smart Business LITE es una app de gestión de ventas y pagos ideal para negocios pequeños con una operativa relativamente sencilla, o bien para negocios más grandes que deseen un complemento a su <a href="#" @click="visitSbf()">BBVA Smart Business (FULL)</a>.</p>
          <p>Si buscas una gestión más completa para tu negocio, <a href="#" @click="visitSbf()">BBVA Smart Business (FULL)</a> es lo que necesitas. Una versión más avanzada que, entre otras opciones, permite utilizar más dispositivos, controlar el stock, comunicar con tu personal y tus clientes y conectar integraciones adicionales.</p>
          <p>Teniendo la versión FULL, igualmente puedes contratar también LITE como complemento para disponer de un terminal híbrido que funcione como punto de venta extra y como datáfono.</p>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  // import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      // I18n,
    ],

    methods: {
      visitSbf () {
        AndroidDevice.visit('https://www.bbva.es/empresas/productos/tpv/smartbusiness-gestion-punto-de-venta.html')
      },
    },
  }
</script>

<style scoped>
  .h-panel-header {
    line-height: 1.2;
  }
  .divider {
    width: 90%;
    height: 1px;
    background-color: #de5813;
  }
</style>
